// When Twilio's own dead-input detector fired on this call, and for how long.
//
// It raises and clears repeatedly on a flat mic, so it is counted and timed rather than
// listed.

export const INPUT_LEVEL_WARNING = 'constant-audio-input-level';

interface InputWarning {
  count: number;
  firstAt: number | null;
  openSince: number | null;
  raisedMs: number;
}

export function newInputWarning(): InputWarning {
  return { count: 0, firstAt: null, openSince: null, raisedMs: 0 };
}

export function inputWarningRaised(w: InputWarning, now: number): void {
  if (w.openSince != null) return;
  w.count += 1;
  w.firstAt ??= now;
  w.openSince = now;
}

export function inputWarningCleared(w: InputWarning, now: number): void {
  if (w.openSince == null) return;
  w.raisedMs += Math.max(0, now - w.openSince);
  w.openSince = null;
}

export interface InputWarningReport {
  sdk_warn_input_level_count: number;
  sdk_warn_input_level_ms: number;
  // Relative to accept; negative when raised while ringing.
  sdk_warn_input_level_first_ms: number | null;
}

export function reportInputWarning(
  w: InputWarning,
  acceptedAt: number | null,
  now: number,
): InputWarningReport {
  const open = w.openSince == null ? 0 : Math.max(0, now - w.openSince);
  return {
    sdk_warn_input_level_count: w.count,
    sdk_warn_input_level_ms: Math.round(w.raisedMs + open),
    sdk_warn_input_level_first_ms:
      w.firstAt == null || acceptedAt == null ? null : Math.round(w.firstAt - acceptedAt),
  };
}
